import request from '../request'

export const memoApi = {
  // 获取所有备忘时间
  getMemoTime () {
    return request.get('memo/getMemoTime')
  },

  // 获取备忘列表
  getMemoList () {
    return request.get('memo/getMemoList')
  },

  // 创建备忘
  createMemo (data) {
    return request.post('memo/createMemo', data)
  },

  // 更新备忘
  updateMemo (data) {
    return request.put('memo/updateMemo', data)
  },

  // 删除备忘
  deleteMemo (id) {
    return request.get('memo/deleteMemoById', { params: { id } })
  },

  // 更改备忘状态
  changeState (id) {
    return request.get('memo/changeState', { params: { id } })
  },

  // 根据时间查找备忘
  findMemo (time) {
    return request.get('memo/findMemo', { params: { time } })
  },

  // 创建备忘
  creatMemo (data) {
    return request.post('memo/creatMemo', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/memo.js